import { render, staticRenderFns } from "./GuestBookSubmitted.vue?vue&type=template&id=69329428&scoped=true&"
import script from "./GuestBookSubmitted.vue?vue&type=script&lang=js&"
export * from "./GuestBookSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./GuestBookSubmitted.vue?vue&type=style&index=0&id=69329428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69329428",
  null
  
)

export default component.exports